import React, {useEffect, useState} from 'react';
import axios from 'axios';
import {DataGrid, GridToolbar} from '@mui/x-data-grid';
import {baseUrl} from '../Univ';
function BudgetMaster() {
    const [rows, setRows] = useState([]);
    const [registerFormData, setRegisterFormData] = useState({
        budget_name: '',
        financial_year: '',
        from_date: '',
        to_date: '',
    });
    // =====================================================
    // FETCH DATA
    // =====================================================
    const fetchData = () => {
        axios.get(`${baseUrl}budget-master-create/`)
            .then((res) => {
                setRows(res.data);
            })
            .catch((err) => {
                console.log(err);
            });
    };
    useEffect(() => {
        fetchData();
    }, []);
    // =====================================================
    // INPUT CHANGE
    // =====================================================
    const inputHandler = (event) => {
        setRegisterFormData({
            ...registerFormData,
            [event.target.name]: event.target.value
        });
    };
    // =====================================================
    // SAVE
    // =====================================================
    const submitHandler = (e) => {
        e.preventDefault();
        const formData = new FormData();
        formData.append(
            'budget_name',
            registerFormData.budget_name
        );
        formData.append(
            'financial_year',
            registerFormData.financial_year
        );
        formData.append(
            'from_date',
            registerFormData.from_date
        );
        formData.append(
            'to_date',
            registerFormData.to_date
        );
        axios.post(
            `${baseUrl}budget-master-create/`,
            formData
        )
            .then(() => {
                fetchData();
                setRegisterFormData({
                    budget_name: '',
                    financial_year: '',
                    from_date: '',
                    to_date: '',
                });
            })
            .catch((err) => {
                console.log(err);
            });
    };
    // =====================================================
    // DATAGRID COLUMNS
    // =====================================================
    const columns = [
        {
            field: 'id',
            headerName: 'ID',
            width: 90
        },
        {
            field: 'budget_name',
            headerName: 'Budget Name',
            width: 250
        },
        {
            field: 'financial_year',
            headerName: 'Financial Year',
            width: 180
        },
        {
            field: 'from_date',
            headerName: 'From Date',
            width: 150
        },
        {
            field: 'to_date',
            headerName: 'To Date',
            width: 150
        },
    ];
    return (
        <section className='container mt-4'>

            <h3 className='bg-primary text-white p-2 text-center'>
                Budget Master
            </h3>

            <form onSubmit={submitHandler}>

                <div className='row'>

                    <div className='col-md-3 mb-2'>

                        <input
                            type='text'
                            name='budget_name'
                            className='form-control'
                            placeholder='Budget Name'
                            value={registerFormData.budget_name}
                            onChange={inputHandler}
                        />

                    </div>

                    <div className='col-md-2 mb-2'>

                        <input
                            type='text'
                            name='financial_year'
                            className='form-control'
                            placeholder='2025-2026'
                            value={registerFormData.financial_year}
                            onChange={inputHandler}
                        />

                    </div>

                    <div className='col-md-2 mb-2'>

                        <input
                            type='date'
                            name='from_date'
                            className='form-control'
                            value={registerFormData.from_date}
                            onChange={inputHandler}
                        />

                    </div>

                    <div className='col-md-2 mb-2'>

                        <input
                            type='date'
                            name='to_date'
                            className='form-control'
                            value={registerFormData.to_date}
                            onChange={inputHandler}
                        />

                    </div>

                    <div className='col-md-2 mb-2'>

                        <button
                            type='submit'
                            className='btn btn-success w-100'
                        >
                            Save
                        </button>

                    </div>

                </div>

            </form>

            <div style={{height: "100%", width: "100%"}}>

                <DataGrid

                    className="mt-4"

                    sx={{
                        boxShadow: 4,
                        border: 4,
                        borderColor: 'primary.light',
                        '& .MuiDataGrid-cell:hover': {
                            color: 'primary.main',
                        },
                    }}

                    rows={rows}
                    columns={columns}
                    pageSize={10}
                    autoHeight

                    components={{
                        Toolbar: GridToolbar,
                    }}

                />

            </div>

        </section>
    )
}
export default BudgetMaster;